/**
 * Whether a product made it onto the brand's Online Store.
 *
 * Shopify creates products unpublished, so the backend publishes them right
 * after creation. `missing_scope` means the store connection predates the
 * publications permissions — the brand must reconnect Shopify to fix it.
 */
export type OnlineStorePublishStatus = 'published' | 'unpublished' | 'missing_scope' | 'no_online_store' | 'failed' | 'skipped';

export interface OnlineStorePublishProduct {
    productType: string;
    shopifyProductId: string;
    status: OnlineStorePublishStatus;
    message?: string;
}

/** Attached to release / add-to-storefront responses as `online_store_publish`. */
export interface OnlineStorePublishSummary {
    status: OnlineStorePublishStatus;
    reconnectRequired: boolean;
    products: OnlineStorePublishProduct[];
}

export interface DisconnectShopifyResult {
    disconnected: boolean;
    shopify_brand_name: string | null;
}

/** Deep link to the Shopify connection settings. */
export const CHANNEL_SETTINGS_PATH = '/settings?tab=channels';
